import { usePageContext } from './use-page-context'
import { useAgency } from './use-agency'

export function useLocale() {
  const { agency } = useAgency()
  return usePageContext().locale ?? agency.locale
}
